import {Component, Injector} from '@angular/core';
import {CurrencyState, Store} from './state/store';
import {Currency} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {CurrencyQuery} from './state/query';
import {CurrencyService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class CurrencyListComponent extends EntityListComponent<Currency, CurrencyState, Store> {

  translationDomain = 'currency';

  constructor(
    public injector: Injector,
    protected service: CurrencyService,
    query: CurrencyQuery,
    private CurrencyFilterService: FilterService) {
    super(injector, service, query, CurrencyFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }
}
